'use client';

import { MEDUSA_BACKEND_URL, queryClient } from '@lib/config';
import { AccountProvider } from '@lib/context/account-context';
import { CartDropdownProvider } from '@lib/context/cart-dropdown-context';
import { MobileMenuProvider } from '@lib/context/mobile-menu-context';
import { StoreProvider } from '@lib/context/store-context';
import { MedusaProvider, CartProvider } from 'medusa-react';
import { MaintenanceProvider } from '@lib/context/maintenance-context';
import { GiftCardsLimitProvider } from '@lib/context/gift-cards-limit-context';

import { ThemeProvider } from '@material-tailwind/react';
import { CLIENT_API_KEY } from '@lib/constants/variants';
import { ConfigStoreClosedProvider } from '@lib/context/store-closed-context';
import { SearchServiceProvider } from '@lib/context/search-service-context';
import { KarunaProvider } from '@lib/context/kurana-context';

export default function Providers({ children }: { children: React.ReactNode }) {
  const customHeaders = {
    'x-api-key': CLIENT_API_KEY,
  };

  return (
    <MedusaProvider
      baseUrl={MEDUSA_BACKEND_URL}
      queryClientProviderProps={{
        client: queryClient,
      }}
      customHeaders={customHeaders}
    >
      <KarunaProvider>
        <CartDropdownProvider>
          <MobileMenuProvider>
            <SearchServiceProvider>
              <CartProvider>
                <AccountProvider>
                  <GiftCardsLimitProvider>
                    <StoreProvider>
                      <MaintenanceProvider>
                        <ConfigStoreClosedProvider>
                          <ThemeProvider>{children}</ThemeProvider>
                        </ConfigStoreClosedProvider>
                      </MaintenanceProvider>
                    </StoreProvider>
                  </GiftCardsLimitProvider>
                </AccountProvider>
              </CartProvider>
            </SearchServiceProvider>
          </MobileMenuProvider>
        </CartDropdownProvider>
      </KarunaProvider>
    </MedusaProvider>
  );
}
